import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bscarousel',
	templateUrl:'./BSCarouselPluginCompPage.html',
	styles: [],
	styleUrls:['./BSCarouselPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSCarouselPluginCompPage
{
	mdContent_794 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.carousel.BSCarousel;
\`\`\``;
	mdContent_795 = `\`\`\`java
BSCarousel()
\`\`\``;
	mdContent_796 = `\`\`\`java
BSCarousel&lt;?&gt; carousel = new BSCarousel&lt;&gt;();
carousel.setShowNavigationArrows(true);
carousel.setShowNavigationIndicators(true);
carousel.setInterval(5000);
carousel.addSlide(new BSCarouselSlide&lt;&gt;("/img/slide1.jpg"));
carousel.addSlide(new BSCarouselSlide&lt;&gt;("/img/slide2.jpg"));
\`\`\``;
}
